import { Label } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { PiStarFill } from 'react-icons/pi';
import { NOTIFICATION_STATUS } from 'services/notifications/types/enums';

export interface ILabelNotificationNewProps {
  status: NOTIFICATION_STATUS;
}

const LabelNotificationNew = ({ status }: ILabelNotificationNewProps) => {
  const { t } = useTranslation();

  if (status !== NOTIFICATION_STATUS.NotDisplayed) {
    return null;
  }

  return (
    <Label
      size='compact'
      color='red'
      title={t('notification.status.new')}>
      <PiStarFill /> {t('notification.status.new')}
    </Label>
  );
};

export default LabelNotificationNew;
